import { useCallback } from 'react';
import { useStore } from 'react-redux';
import { withScope } from '@/store';

/**
 * For async tenant writers: call `begin()` when the request STARTS; it captures
 * the current scope generation and returns a dispatch that stamps every action
 * with it, so a response landing after a scope switch (enter/leave enterprise,
 * Manage, impersonation) is dropped by the root reducer.
 */
export default function useScopedDispatch() {
  const store = useStore();
  return useCallback(() => {
    const gen = store.getState().session.scopeGen;
    return (action) => store.dispatch(withScope(action, gen));
  }, [store]);
}
